module.exports = __webpack_public_path__ + "static/media/48_B.99abe9be.png";